import { render } from "./notice.vue?vue&type=template&id=10a7b76c&scoped=true"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"

import "./notice.vue?vue&type=style&index=0&id=10a7b76c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a7b76c"]])

export default __exports__